import styled from "styled-components";
const StyledHeader = styled.header`
  transition: background 0.2s;
  position: fixed;
  top: 0;
  background: white;
  height: auto;
  width: 100%;
  z-index: 10;
  margin-top: 0 !important;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  .logoImage {
    height: 5rem;
    padding-bottom:0.5rem;
  }
  .nav-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .user-way {
    position: absolute;
    right: -3rem;
  }

  @media (max-width: 991px) {
    justify-content: center;
    margin: 1rem 0;
    .logoImage {
      height: 4rem;
    }
    .nav-box {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  @media (max-width: 768px) {
    align-items: flex-start;
    justify-content: center;
  }
  @media (max-width: 450px) {
    .logoImage {
      height: 3.5rem;
    }
    .user-way {
      right: -3rem!important;
    }
  }
  @media(max-width:400px){
    .user-way {
      right: -2rem!important;
    }
  }
  @media(max-width:350px){

    .user-way {
      right: -3rem!important;
    }
  }
`;
export default StyledHeader;
